// src/pages/HomePage.js
import React from 'react';
import styled from 'styled-components';
import { Helmet } from 'react-helmet-async';
import HeroSection from '../components/HeroSection';
import WhyTrustUs from '../components/WhyTrustUs';
import Features from '../components/Features';
import AppShowcase from '../components/AppShowcase';
import FAQSection from '../components/FAQSection';
import TokenTicker from '../components/TokenTicker';

const HomePageContainer = styled.div``;

const HomePage = () => {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "MobileApplication",
    "name": "Trend Genie",
    "operatingSystem": "Android",
    "applicationCategory": "FinanceApplication",
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5",
      "ratingCount": "104"
    },
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    },
    "description": "Trend Genie is an AI-powered trading signal app that provides crypto and stock signals, real-time analysis, and actionable trade setups.",
    "image": [
      "https://www.trendgenie.io/assets/app-cover.png"
    ],
    "url": "https://www.trendgenie.io",
    "downloadUrl": "https://play.google.com/store/apps/details?id=com.entiresolutions.trendgenie",
    "author": {
      "@type": "Organization",
      "name": "Trend Genie",
      "url": "https://www.trendgenie.io"
    }
  };

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Trend Genie",
    "url": "https://www.trendgenie.io",
    "logo": "https://www.trendgenie.io/logo.png",
    "sameAs": [
      "https://www.facebook.com/",
      "https://www.instagram.com/",
      "https://www.twitter.com/"
    ],
    "description": "AI-powered trading signals for crypto & stocks. Real-time analysis, automated trade detection, and instant alerts."
  };

  return (
    <HomePageContainer>

      {/* =======================
          SEO + META TAGS
      ======================== */}
      <Helmet>
        <title>Trend Genie: AI-Powered Trading Signals for Crypto & Stocks</title>

        <meta
          name="description"
          content="Trend Genie delivers AI-powered trading analysis, real-time crypto signals, stock signals, and automated take-profit/stop-loss insights. Your personal AI trading assistant."
        />

        <meta name="keywords" content="
            AI trading app,
            crypto signals app,
            stock trading signals,
            automated trading signals,
            trade alerts,
            market AI analysis,
            crypto AI tool,
            trading bot,
            trading algorithm app,
            Trend Genie
        " />

        {/* Canonical */}
        <link rel="canonical" href="https://www.trendgenie.io/" />

        {/* Open Graph (Facebook, Instagram, WhatsApp) */}
        <meta property="og:title" content="Trend Genie – AI Trading Signals for Crypto & Stocks" />
        <meta property="og:description" content="Get AI-generated signals with entry, stop-loss, and take-profit levels. Trade smarter, faster, and with confidence." />
        <meta property="og:image" content="https://www.trendgenie.io/assets/app-og.png" />
        <meta property="og:url" content="https://www.trendgenie.io/" />
        <meta property="og:type" content="website" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Trend Genie – AI Trading Signals App" />
        <meta name="twitter:description" content="AI-powered trading signals for crypto & stocks. Real-time alerts, automated setups, and precision analysis." />
        <meta name="twitter:image" content="https://www.trendgenie.io/assets/app-og.png" />

        {/* Mobile App Indexing */}
        <meta name="mobile-web-app-capable" content="yes" />
        <meta name="apple-mobile-web-app-title" content="Trend Genie" />
        <meta name="theme-color" content="#111827" />

        {/* Schema Markup */}
        <script type="application/ld+json">
          {JSON.stringify(schemaData)}
        </script>

        <script type="application/ld+json">
          {JSON.stringify(organizationSchema)}
        </script>
      </Helmet>

      {/* =======================
          Page Sections
      ======================== */}
      <HeroSection />
      <TokenTicker />
      <Features />
      <AppShowcase />
      <WhyTrustUs />
      {/*<FAQSection />*/}
    </HomePageContainer>
  );
};

export default HomePage;
